





















import Vue from "vue";
import { Component, Prop, Provide } from "vue-property-decorator";
import CollectionMap from "./components/Map.vue";
import MapConfig from "./mapConfig.model";
import TableConfig from "./tableConfig.model";
import MapTable from "./components/MapTable.vue";
import MapSpinner from "./components/MapSpinner.vue";
import { CobMarker, MapLayer, TableData } from "./types";

@Component({
  components: {
    CollectionMap,
    MapTable,
    MapSpinner
  }
})

export default class App extends Vue {
  @Prop({ default: new MapConfig() }) mapconfig!: MapConfig;
  @Prop({ default: null }) markers!: CobMarker[];
  @Prop({ default: null }) showmarker!: CobMarker;
  @Prop({ default: null }) layers!: MapLayer[];
  tableData: TableData = new TableConfig();//{ items: [], fields: [], sortBy: "" };
  dataReady: boolean = false;

  onTableDataChange(value: TableData) {   
    if(value){        
      this.tableData = value;
      this.dataReady = true;
    }
    
  }

  onFindLocation(id: number) {
    // eslint-disable-next-line
    // console.log(id);
  }
  openPopup(){
    //dostuff
  }
}
